import React, { Component } from 'react';

import styles from  './styles.js';


class Kontakt extends Component {
	render() {

		let elmStyl = Object.assign({}, styles.container, {
		});

		let st = {
			h1: {
				color: '#172686'
			},
			p : {
				color: '#ff0000'
			}
		}



		return (
			<div style={elmStyl} className='contact'>
				<div style={styles.flex}>
					<div
						data-start="margin-top: -4000px"
						data-center="margin-top: 0px"
						>
						<h1 style={st.h1}>
							Kontakt os
						</h1>
						<p style={st.p}>
							Byg et digt
						</p>
						<p style={st.p}>
							mail: <a style={st.h1} href='mailto:BygEtDigt@Gmail.com'>BygEtDigt@Gmail.com</a>
						</p>
						<p style={st.p}>
							Gitte: 24 84 74 31 & Henrik: 30 50 09 03
						</p>
						<p style={st.p}>
							www.BygEtDigt.dk
						</p>
						
					</div>
				</div>
			</div>

		)
	}
}

export default Kontakt;



// WEBPACK FOOTER //
// ./src/components/Kontakt.js